/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle01Icon16Light } from './NumberCircle01Icon16Light';
import { NumberCircle01Icon16Regular } from './NumberCircle01Icon16Regular';
import { NumberCircle01Icon16Solid } from './NumberCircle01Icon16Solid';
import { NumberCircle01Icon20Light } from './NumberCircle01Icon20Light';
import { NumberCircle01Icon20Regular } from './NumberCircle01Icon20Regular';
import { NumberCircle01Icon20Solid } from './NumberCircle01Icon20Solid';
import { NumberCircle01Icon24Regular } from './NumberCircle01Icon24Regular';
import { NumberCircle01Icon24Solid } from './NumberCircle01Icon24Solid';
import { NumberCircle01Icon32Regular } from './NumberCircle01Icon32Regular';
import { NumberCircle01Icon64Regular } from './NumberCircle01Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle01Icon16Light,
        regular: NumberCircle01Icon16Regular,
        solid: NumberCircle01Icon16Solid,
    },
    20: {
        light: NumberCircle01Icon20Light,
        regular: NumberCircle01Icon20Regular,
        solid: NumberCircle01Icon20Solid,
    },
    24: {
        regular: NumberCircle01Icon24Regular,
        solid: NumberCircle01Icon24Solid,
    },
    32: {
        regular: NumberCircle01Icon32Regular,
    },
    64: {
        regular: NumberCircle01Icon64Regular,
    },
};
export var NumberCircle01Icon = forwardRef('NumberCircle01Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
